export default function Hero() {
  const scrollToMentores = () => {
    const element = document.getElementById('mentores');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="bienvenida" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://readdy.ai/api/search-image?query=Modern%20abstract%20technology%20background%20with%20geometric%20patterns%20in%20deep%20navy%20blue%20and%20golden%20amber%20tones%2C%20professional%20educational%20atmosphere%2C%20clean%20minimalist%20design%2C%20soft%20gradients%2C%20digital%20innovation%20concept%2C%20university%20campus%20aesthetic%2C%20contemporary%20learning%20environment%20illustration&width=1920&height=1080&seq=hero-bg&orientation=landscape"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1b3d70]/85 via-[#1b3d70]/75 to-[#1b3d70]/85"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="animate-fade-in">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Speed Mentoring
          </h1>
          <p className="text-xl sm:text-2xl text-[#bb8800] font-semibold mb-8">
            Conectando Estudiantes con Expertos de la Industria
          </p>
          <p className="text-lg sm:text-xl text-white/90 max-w-3xl mx-auto mb-12 leading-relaxed">
            Sesiones dinámicas de 20 minutos con profesionales destacados en diferentes áreas de computación. 
            Impulsa tu carrera profesional con la experiencia de quienes ya están en la industria.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button 
              onClick={scrollToMentores}
              className="bg-[#bb8800] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#996d00] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer transform hover:scale-105"
            >
              Explorar Mentores
            </button>
            <button 
              onClick={() => {
                const element = document.getElementById('como-funciona');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white text-[#1b3d70] px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer transform hover:scale-105"
            >
              Cómo Funciona
            </button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-20 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-[#bb8800] mb-2">20</div>
            <div className="text-white text-sm">Minutos por Sesión</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-[#bb8800] mb-2">12+</div>
            <div className="text-white text-sm">Mentores Expertos</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-[#bb8800] mb-2">100%</div>
            <div className="text-white text-sm">Enfoque Práctico</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/70"></i>
      </div>
    </section>
  );
}